import { callAxios, dev_console, isSuccess, whoAmI } from "../../../../Common/ts/commonTools";
import { Delivery_Address_data_Interface, ProductDetail_SelectInformationDate_Address_Interface } from "../../static/interface/ProductDetail.interface";
import { defaultApiReaponseInterface } from "../../../../Common/interface/Common.interface";
import { RTN_interface } from "../../../../Common/interface/App.interface";
import useCustomQuery from "../../../../Common/hooks/useCustomQuery";

const EMTPY_LIST: ProductDetail_SelectInformationDate_Address_Interface[] = [];

const useDeliveryAddressListREST = () => {

    const {
        data: deliveryAddressListData = EMTPY_LIST,
        isLoading: deliveryAddressListIsLoading,
        error: deliveryAddressListError,
        refetch: deliveryAddressListRefetch,
    } = useCustomQuery({
        queryKey: ["useDeliveryAddressListREST"],
        queryFn: getAddressListData,
        enabled: isAbleToRequest(),
        select: (response) => {
            const RTN: RTN_interface<Delivery_Address_data_Interface[]> = {
                sign: false,
                data: EMTPY_LIST,
                msg: "",
            }

            SetData:{
                if(!response){
                    RTN.msg = "데이터를 불러오지 못했습니다.";
                    break SetData;
                }

                if(!isSuccess(response)){
                    RTN.msg = "성공적인 응답이 아닙니다.";
                    break SetData;
                }

                const data: defaultApiReaponseInterface<Delivery_Address_data_Interface[]> = response.data;

                RTN.sign = true;
                RTN.msg = "success";
                RTN.data = data.result;
            }

            if(!RTN.sign){
                dev_console.error(RTN.msg);
            }

            return RTN.data;
        },
    })

    function isAbleToRequest(){
        let RTN = false;

        if(whoAmI.isCustomer()){
            RTN = true;
        }

        return RTN;
    }
    
    async function getAddressListData(){
        const m_delivery_address_url = "api/v3/oops/customer/delivery/address2";

        const response = await callAxios.api({
            url: m_delivery_address_url,
            method: "get",
        })

        dev_console.log(m_delivery_address_url);
        dev_console.log(response);

        return response;
    } 

    return({
        deliveryAddressListData,
        deliveryAddressListIsLoading,
        deliveryAddressListError,
        deliveryAddressListRefetch,
    })
}

export default useDeliveryAddressListREST;